import React, { useEffect } from 'react';
import { useAuth, Guild } from '../context/auth-context';
import { discordService } from '../services/discord-service';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const { user, guilds, isAuthenticated, isLoading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, authLoading, navigate]);

  const handleUpdateConfig = (guild: Guild) => {
    navigate(`/profile/config/${guild.id}`);
  };

  if (authLoading) {
    return <div className="page-container"><h1>Loading...</h1></div>;
  }

  if (!user) {
    return null;
  }

  return (
    <div className="container profile-page">
      <section className="user-info">
        <div className="user-profile-header">
          <img 
            src={discordService.getAvatarUrl(user.id, user.avatar)} 
            alt={user.username} 
            className="user-avatar"
          />
          <div className="user-details">
            <h1>Welcome, {user.username}</h1>
            <p>Manage your Harambot settings for your Discord servers.</p>
          </div>
        </div>
      </section>

      <section className="guilds-section">
...
        <div className="guilds-grid">
          {guilds.map((guild) => (
            <div key={guild.id} className="guild-card">
              <img 
                src={discordService.getGuildIconUrl(guild.id, guild.icon)} 
                alt={guild.name} 
                className="guild-icon"
              />
              <h3 className="guild-name">{guild.name}</h3>
              <div className="guild-actions">
                <a 
                  href={discordService.getAddBotUrl(guild.id)} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-small"
                >
                  Add Bot
                </a>
                <button 
                  onClick={() => handleUpdateConfig(guild)}
                  className="btn btn-small btn-secondary"
                >
                  Settings
                </button>
              </div>
            </div>
          ))}
          {guilds.length === 0 && (
            <p className="no-guilds">No servers found where you have management permissions.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default Profile;
